import React, { useContext, useEffect, useState } from "react";
import { motion } from "framer-motion";
import styles from "./Home.module.scss";
import { Context } from "../Store";
import backgroundBubbleR from "../../imgs/background1r.png";
import backgroundBubbleL from "../../imgs/background1l.png";
import backgroundBubbleRR from "../../imgs/background1rR.png";
import backgroundBubbleLR from "../../imgs/background1lR.png";
import downArraw from "../../imgs/downArraw.svg";
import Services from "./Services/Services";
import Partners from "./Partners/Partners";
import MoreServices from "./MoreServices/MoreServices";
import Packages from "./Packages/Packages";
import SubscriptionsLink from "./SubscriptionsLink/SubscriptionsLink";

import HomeFooter from "./HomeFooter/HomeFooter";
import Loading from "../Loading/Loading";

const Home = () => {
  let {
    dir,
    translate,
    setIsClicked,
    setIsHovering,
    homeSection,
    servicesSection,
    scrollToSection,
    variants1,
    clickBtn,
    clickbtns,
    siteInfoRes,
    siteInfoLoading,
  } = useContext(Context);
  let { homeTitle, homeSubTitle, video, googlePlay } = siteInfoRes;
  let { documentTitle, btn0 } = translate.home;
  const [windowWidth, setWindowWidth] = useState(0);

  useEffect(() => {
    setWindowWidth(window.innerWidth);
    setIsClicked(false);
    setIsHovering(false);
  }, [setIsClicked, setIsHovering]);
  useEffect(() => {
    document.title = dir === "ltr" ? documentTitle[0] : documentTitle[1];
  }, [dir]);
  return (
    <>
      {siteInfoLoading ? (
        <Loading />
      ) : (
        <motion.section
          variants={variants1}
          initial="hidden"
          animate="showComponets"
          exit="exit"
          ref={homeSection}
          id={styles.home}
        >
          <div className={styles.intro}>
            <video
              id={styles.introVideo}
              src={video}
              autoPlay
              muted
              loop
            ></video>
            {/* <div className={styles.backgroundImg} style={dir==="ltl"?{direction:"ltr"}:{direction:"rtl"}}>
          <img src={introImg}  alt="" />
        </div> */}
            <div className={styles.container}>
              {dir === "ltr" ? (
                <img
                  className={styles.backgroundBubbleL}
                  src={
                    windowWidth >= 576 ? backgroundBubbleL : backgroundBubbleLR
                  }
                  alt=""
                />
              ) : (
                <img
                  className={styles.backgroundBubbleR}
                  src={
                    windowWidth >= 576 ? backgroundBubbleR : backgroundBubbleRR
                  }
                  alt=""
                />
              )}
              <h2>{homeTitle}</h2>
              <p>{homeSubTitle}</p>
              <div className={styles.btns}>
                <a href={googlePlay} target="_blank">
                  <button
                    onClick={() => clickBtn("startNow", 70)}
                    className={clickbtns === "startNow" ? "clickBtns" : ""}
                  >
                    {dir === "ltr" ? btn0[0] : btn0[1]}
                  </button>
                </a>
              </div>
              <img
                src={downArraw}
                onClick={() => scrollToSection(servicesSection)}
                className={`${styles.scrollDown}`}
                alt=""
              />
            </div>
          </div>

          <Services googlePlay={googlePlay} />
          <Partners />
          <MoreServices />
          <SubscriptionsLink />
          {/* <Packages /> */}
          <HomeFooter />
        </motion.section>
      )}
    </>
  );
};

export default Home;
